import * as Cookies from "@khan/data-cookies";

/**
 * Reads a cookie and deletes it.
 *
 * NOTE: This function is not idempotent.
 */
const readAndDelete = (name: string): boolean => {
    const value = Cookies.readCookie(name);
    Cookies.eraseCookie(name);
    return Boolean(value);
};

/**
 * Reads then deletes the cookie indicating the user just signed up.
 *
 * This exists so that we can fire client side analytics (i.e.
 * Google Analytics and AdWords trackers) when a user signs up.
 *
 * During the user's first login, a cookie will be set indicating the
 * user has just signed up. On the next page loaded, we check for this
 * cookie and when present emit some extra markup that fires off the
 * relevant events.
 */
export const firstLogin = (kaid: string): boolean =>
    readAndDelete(`first_login_${kaid}`);

/**
 * Reads then deletes the cookie indicating the user just logged in.
 *
 * This exists so that we can execute specifc client side analytics code
 * (i.e. notify Google Analytics) when a returning user logs in.
 */
export const returningLogin = (kaid: string): boolean =>
    readAndDelete(`returning_login_${kaid}`);

/**
 * Reads then deletes the cookie indicating the user just logged out.
 *
 * This exists so that we can execute specific client side analytics code
 * (i.e. end current Google Analytics session) when a user logs out.
 */
export const justLoggedOut = (): boolean => readAndDelete("just_logged_out");
